import { render, staticRenderFns } from "./GiftWithdrawElement.vue?vue&type=template&id=88e2198c&scoped=true"
import script from "./GiftWithdrawElement.vue?vue&type=script&lang=js"
export * from "./GiftWithdrawElement.vue?vue&type=script&lang=js"
import style0 from "./GiftWithdrawElement.vue?vue&type=style&index=0&id=88e2198c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e2198c",
  null
  
)

export default component.exports